<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-20 16:45:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/addresslist/components/AddressItem/index.vue
-->
<template>
  <div class="add_list border_bottom1px" @click.stop="clickAddressItem(rows)">
    <div>
      <div
        class="text_left add_top font16 font_weight500 colo087 line_height_22"
      >
        <span class="add_name">{{ rows.name }}</span>
        <span>{{ rows.phone }}</span>
        <span
          v-if="rows.isDefault"
          class="default_icon font10 font_weight400 colof line_height_14"
          >默认</span
        >
      </div>
      <div
        class="font12 font_weight400 colo087 line_height_17 text_left add_add"
      >
        {{ rows.province }} {{ rows.city }} {{ rows.district }}
        {{ rows.addressLine }}
      </div>
    </div>
    <img
      src="@/assets/common/icon_edit_outline_24@2x.png"
      alt=""
      @click.stop="editAddress(rows.id)"
    />
  </div>
</template>
<script>
export default {
  props: {
    rows: {
      type: Object,
      default() {
        return {};
      }
    },
    rowIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods: {
    editAddress(id) {
      this.$emit("editAddress", id, this.rowIndex);
    },
    clickAddressItem(rows) {
      this.$emit("clickAddressItem", rows);
    }
  }
};
</script>
<style lang="less" scoped>
.add_list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  img {
    width: 24px;
  }
  .add_top {
    display: flex;
    align-items: center;
    .add_name {
      margin-right: 38px;
    }
    .default_icon {
      display: inline-block;
      background: #bf9264;
      border-radius: 2px;
      margin-left: 8px;
      margin-bottom: 2px;
    }
  }
  .add_add {
    margin-top: 9px;
  }
}
</style>
